import { TextField } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import ReadOnlyField from './readonly-field';

interface ConditionalTextFieldProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label: string;
  isReadOnly?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  maxLength?: number;
}

// Named TextInput to not conflict with MUI TextField
const TextInput = <T extends FieldValues>({
  name,
  control,
  label,
  isReadOnly,
  required = false,
  fullWidth = true,
  maxLength,
}: ConditionalTextFieldProps<T>): React.ReactElement => {
  if (isReadOnly) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => <ReadOnlyField label={label} value={field.value} />}
      />
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          fullWidth={fullWidth}
          label={label}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          required={required}
          inputProps={maxLength ? { maxLength } : undefined}
        />
      )}
    />
  );
};

export default TextInput;
